import { render, staticRenderFns } from "./AnnualTotals.vue?vue&type=template&id=ec4a878e"
import script from "./AnnualTotals.vue?vue&type=script&lang=js"
export * from "./AnnualTotals.vue?vue&type=script&lang=js"
import style0 from "./AnnualTotals.vue?vue&type=style&index=0&id=ec4a878e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports